// ============================================
// Enums
// ============================================

export enum VerificationStageStatus {
  NotStarted = 0,
  Assigned = 1,
  WaitingVerification = 2,
  Verified = 3,
  Rejected = 4,
  WaitingSendingTime = 5,
  ProcessingFiles = 6,
}

export enum VerificationStageType {
  System = 0,
  Manual = 1,
}

export enum AttachmentType {
  Image = 1,
  Video = 2,
}

// ============================================
// Core Shared Types
// ============================================

export interface Attachment {
  url: string;
  type: AttachmentType;
}

export interface PaginationState {
  page: number;
  size: number;
}


// ============================================
// Excel Export Types
// ============================================

export type ExcelHeaderCellsName = Record<string, string>;
